<footer class="py-4">
  <div class="container">
    <div class="row ">
      <div class="col-12 col-lg-5 d-flex mb-3 mb-lg-0 align-start">
        <ul class="list-unstyled d-flex mb-2">
          <li>
            <a class="ml-0 pl-0" href="https://br.linkedin.com/company/dinamize_2" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-linkedin.svg" alt="Logo do LinkedIn" class="icon-svg" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/dinamize/" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-instagram.svg" alt="Logo do Instagram" class="icon-svg" />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/dinamize/" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-facebook.svg" alt="Logo do Facebook" class="icon-svg" />
            </a>
          </li>
          <li>
            <a href="https://www.x.com/dinamize/" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-x.svg" alt="Logo do X (Twitter)" class="icon-svg" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/dinamize/" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-youtube.svg" alt="Logo do YouTube" class="icon-svg" />
            </a>
          </li>
          <li>
            <a href="https://tiktok.com/@dinamize.com" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/icons/logo-tiktok.svg" alt="Logo do TikTok" class="icon-svg" />
            </a>
          </li>
        </ul>
        <small>
          <strong>Precisa de ajuda?</strong> Ligue 4007.1251 (capitais) ou (51) 3303.2555, para outras regiões.
        </small>
        <small>
          <strong>Prefere por email?</strong> Fale com a gente em suporte&#64;dinamize.com
        </small>
      </div>
      <div class="logo col-12 col-lg-2 d-flex">
        <img src="./assets/images/logo-dinamize-black.png" alt="Dinamize logo" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <small class="mt-2">
          Dinamize {{ currentYear }} - Todos os direitos reservados.
        </small>
      </div>
    </div>
  </div>
</footer>
